<template>
  <div class=" text-center loader-wrapper">
  <div class=" text-center loader-inner">
  </div>
    <div class="loader-center">
    <img src="/img/l2.png" class="loader" alt="">
    <p class="text-light text-center" style="margin-top: -50px">درحال بارگذاری...</p>
  </div>

  </div>
</template>

<script>
export default {
  name: "Loader"
}
</script>

<style scoped>

</style>